// IE 10-11

const detectIE = () => navigator.userAgent.match(/trident/i);

export default detectIE;



/** WEBPACK FOOTER **
 ** ./app/scripts/util/detect/detectIE.js
 **/